/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, {useContext, useEffect, useState} from 'react';
import {flushSync} from "react-dom";

const WindowContext = React.createContext();

const queryIsMobile = () => {
    return window.matchMedia("only screen and (max-width: 767px)").matches;
};

export const WindowProvider = (props) => {
    const [isMobile, setIsMobile] = useState(queryIsMobile());

    const handleResize = () => {
        let mobile = queryIsMobile();
        if (isMobile !== mobile) {
          flushSync(() => {
            setIsMobile(mobile);
          });
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    return <WindowContext.Provider value={{isMobile}} {...props}/>;
};

export const useWindow = () => {
    const context = useContext(WindowContext);
    if (!context) {
        throw new Error('useWindow must be called within a WindowProvider');
    }
    return context;
};
